import request from '../../../src/utils/request'

export const getStaffChangeRiskOverview = () => {
  return request({
    url: '/addon/staffChangeRisk/overview',
    method: 'get'
  })
}
